export default "__VITE_PUBLIC_ASSET__0d1b19e8__"